import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "./styles/element-variables.scss";
import dayjs from "./utils/dayjs";
import VueDataTables from "vue-data-tables";
import Vue from "vue";
// import VueGtm from 'vue-gtm';
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import VueUploadComponent from "vue-upload-component";
import VueClipboards from "vue-clipboards";
import App from "./App.vue";
import router from "./router";

import LoginLayout from "./layouts/LoginLayout.vue";
import AppLayout from "./layouts/AppLayout.vue";
import LoadingLayout from "./layouts/LoadingLayout.vue";
import { initAuth, getAuth0 } from "@/auth/auth0";

import httpnoauth from "./axios/httpnoauth";
import httpauth from "./axios/httpauth";
import store from "./store";
import "./index.css";

Vue.component("login-layout", LoginLayout);
Vue.component("app-layout", AppLayout);
Vue.component("loading-layout", LoadingLayout);
Vue.component("vue-upload-component", VueUploadComponent);
Vue.component("datetime", Datetime);

Vue.config.productionTip = false;

Vue.prototype.dayjs = dayjs;
Vue.prototype.$noauth = httpnoauth;
Vue.prototype.$http = httpauth;
Vue.prototype.$customError = (msg) => {
  ElementUI.Notification.error({
    title: "Error",
    message: msg || "There has been an error",
    duration: 10000
  });
};
Vue.prototype.$customSuccess = (msg) => {
  ElementUI.Notification({
    title: "Success",
    message: msg || "",
    type: "success",
    customClass: "success"
  });
};

Vue.use(VueClipboards);
Vue.use(ElementUI, { locale });
Vue.use(VueDataTables);

// Vue.use(VueGtm, {
//   id: 'GTM-PV42QSK',
// });

Vue.filter("capitalize", value => {
  if (!value) return "";
  let text = value;
  text = text.toString();
  return text.charAt(0).toUpperCase() + text.slice(1);
});

async function bootstrap() {
  console.log("🚀 Bootstrapping app...");

  // 1. Init Auth0
  await initAuth();
  const auth0 = getAuth0();

  try {
    /**
     * 2. Handle redirect (after Auth0 login)
     */
    if (window.location.search.includes("code=")) {
      console.log("🔁 Handling Auth0 redirect...");

      const { appState } = await auth0.handleRedirectCallback();

      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);

      /**
       * ✅ Get ACCESS TOKEN (NOT id_token)
       * IMPORTANT: audience must match backend API identifier
       */
      const accessToken = await auth0.getTokenSilently({
        audience: process.env.VUE_AUTH_AUDIENCE,
      });

      console.log("🔐 Access token received (redirect flow)");

      /**
       * ✅ Call backend login
       */
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/nrl/api/v1/admin/login/token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Backend login failed");
      }

      const data = await response.json();

      /**
       * ✅ Save backend tokens (StatEdge tokens)
       */
      store.commit("user/login", data);

      /**
       * ✅ Redirect user
       */
      router.replace(appState?.target || "/");
    }

    /**
     * 3. Existing session (page refresh case)
     */
    const isAuthenticated = await auth0.isAuthenticated();
    console.log("isAuthenticated:", isAuthenticated);

    if (isAuthenticated && !store.state.user?.isLoggedIn) {
      console.log("♻️ Restoring session...");

      const accessToken = await auth0.getTokenSilently({
        audience: process.env.VUE_AUTH_AUDIENCE,
      });

      console.log("🔐 Access token received (silent)");

      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/nrl/api/v1/admin/login/token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Backend login failed (silent)");
      }

      const data = await response.json();

      store.commit("user/login", data);
    }
  } catch (err) {
    console.error("❌ Auth error:", err);
  }

  /**
   * 4. Start Vue app (ONLY ONCE)
   */
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

/* ---------------- START APP ---------------- */
bootstrap();
